import api from "@/interceptors";
import store from "@/store";
import { ProspectRoute, Route } from "../apiRoutes/routes";

export default class {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  saveProspectVerify(data: object, recaptcha: any): any {
    return new Promise((resolve, reject) => {
      api
        .post(ProspectRoute.verify, data, {
          params: { "g-recaptcha-response": recaptcha },
        } as any)

        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  verifyProspect(data: any): any {
    return new Promise((resolve, reject) => {
      const body = {};
      const params = {
        token: data.token,
        "g-recaptcha-response": data.recaptcha,
      };
      api
        .post(ProspectRoute.callback, body, { params })
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getProspectQuestions(data: any): any {
    return new Promise((resolve, reject) => {
      api
        .get(ProspectRoute.getQuests, {
          params: {
            id_language: data.language,
          },
        } as any)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  saveProspectQuestions(data: object): any {
    return new Promise((resolve, reject) => {
      api
        .post(ProspectRoute.setQuests, { data: data })
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getReCaptcha(): any {
    return new Promise((resolve, reject) => {
      api
        .get(Route.rc3Script)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getDomainsList(data: any): any {
    return new Promise((resolve, reject) => {
      api
        .get(ProspectRoute.getProspectDomainsInvalid, {
          params: { "g-recaptcha-response": data },
        })
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  savePassword(data: any): any {
    return new Promise((resolve, reject) => {
      api
        .post(ProspectRoute.toUser, { password: data })
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  verifyPassphrase(data: any): any {
    return new Promise((resolve, reject) => {
      api
        .post(ProspectRoute.preview, { passphrase: data })
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  logout(): any {
    return new Promise((resolve, reject) => {
      api
        .post(ProspectRoute.logout)
        .then((result) => {
          store.dispatch("User/unauthenticateUser");
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
